module.exports = __webpack_public_path__ + "static/media/team-2@3x.ed133050.jpg";